<template>
  <div id="app">    
    <MYHeader />
    <MYMain />
    <MYFooter />
  </div>
</template>

<script>
import MYHeader from './header/MYHeader.vue'
import MYMain from './main/MYMain.vue'
import MYFooter from './footer/MYFooter.vue'

export default {
  name: 'App',
  components: {
    MYHeader,
    MYMain,
    MYFooter
  },
  created() {
    this.getUrlParams();
    this.$store.commit('initObjetosBase');
  },
  methods: {
    getUrlParams(){
      const urlParams = new URLSearchParams(window.location.search);
      // UTMs
      const utmParams = {
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_term: urlParams.get('utm_term'),
        utm_content: urlParams.get('utm_content'),
        gclid: urlParams.get('gclid'),
        my_campaign: urlParams.get('my_campaign')
      };
      this.$store.commit('setUTMParams',{utmParams: utmParams});
    }
  }
}
</script>

<style>
  @font-face {
      font-family: 'Avenir Next';
      src: url('@/assets/fonts/AvenirNext-Regular.woff2') format('woff2'),
          url('@/assets/fonts/AvenirNext-Regular.woff') format('woff');
      font-weight: lighter;
      font-style: normal;
      font-display: swap;
  }
  @font-face {
      font-family: 'Avenir Next';
      src: url('@/assets/fonts/AvenirNext-Medium.woff2') format('woff2'),
          url('@/assets/fonts/AvenirNext-Medium.woff') format('woff');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
}

@font-face {
    font-family: 'Avenir Next';
    src: url('@/assets/fonts/AvenirNext-Bold.woff2') format('woff2'),
        url('@/assets/fonts/AvenirNext-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}


  #app {
    padding-top: var(--header-height);
    width: 100%;
  }
  :root {
    --border-radius: 8px;
    --shadow-color: rgba(0, 0, 0, 0.3);
    /* COLORES */
    --primary: #0046DE;
    --primary-dark: #16569c;
    --primary-light: #e8f0f9;
    --white: #fff;
    --black: #000;
    --dark: #282828;
    --gray: #9e9e9e;
    --gray-dark-light: #b7b7b7;
    --gray-dark: #757575;
    --gray-light: #d8d8d8;
    --success: #1aaa69;
    --success-dark: #137e4e;
    --success-light: #e8f7f0;
    --info: #007bb6;
    --info-dark: #005983;
    --info-light: #e8f0f9;
    --warning: #f3b524;
    --warning-dark: #d89b0c;
    --warning-light: #fdf0d3;
    --danger: #e62619;
    --danger-dark: #b81e14;
    --danger-light: #fce9e8;
    /* MEDIDAS */
    --spacer: 16px;
    --transition: 0.35s ease-in-out;
    --header-height: 60px;
    --footer-height: 336px;
    /* FUENTE  */
    --font-weight-regular: 400;
    --font-weight-medium: 500;
    --font-weight-bold: 700;
    --font-size-inputs: 16px;
    --font-size-buttons: 16px;
  }
  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: var(---black);
  }
  body, html {
    background: var(--white);
    overscroll-behavior: none;
  }
  body {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    color: var(--dark);
    font-family: "Avenir Next", sans-serif;
    font-size: var(--font-size-inputs);
    font-weight: var(--font-weight-regular);
    text-align: left;
  }

  /* BOTONES */
  .button {
    background: transparent;
    border: 1px solid transparent;
    cursor: pointer;
    font-size: var(--font-size-buttons);
    font-weight: var(--font-weight-bold);
    line-height: 24px;
    min-width: calc(var(--spacer)* 8);
    height: 48px;
    outline: none;
    padding: 12px 24px;
    position: relative;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .button.rounded {
    border-radius: calc(var(--spacer)* 1.5);
  }
  button, button:active, button:focus, button:hover {
    outline: none;
  }
  .button.primary {
    background: var(--primary);
    border-color: var(--primary);
    color: var(--white);
  }
  .button.tertiary {
    background: var(--white);
    border-color: var(--primary);
    color: var(--primary);
  }
  .button.secondary {
    background: var(--white);
    border-color: var(--white);
    color: var(--primary);
  }    
  .button.tertiary:hover {
    background: var(--primary);
    border-color: var(--primary);
    color: var(--white);
  }
  .primary:disabled {
    background: var( --gray-dark-light); 
    border-color: var(--gray-dark-light); 
    cursor: not-allowed;
  }
  .secondary:disabled {
    color: var(--gray-dark-light); 
    cursor: not-allowed;
  }
  .button+.button {
    margin-left: 0;
  }


  /* VISTAS ESPECIALES */
  .specialView-container {
    max-width: 1440px;
    margin: 3% auto 0;
    display: flex;
    min-height: calc(100vh - (var(--header-height) + var(--footer-height)));
  }
  .specialView-container > *:nth-child(1),
  .specialView-container > *:nth-child(2) {
    flex: 1; /* Repartir el espacio equitativamente */
  }
  .specialView-info_container { 
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2% 7%;
    order: 1; 
  }
  .specialView-image_container{
    display: flex; 
    justify-content: center; 
    align-items: center; 
    order: 2; 
  }
  .specialView-info_title {
    margin: 0 ;
    font-size: 30px;
    font-weight: var(--font-weight-bold);
    line-height: 42px;
  }
  .specialView-info_text {
    margin: 20px 0 32px;
    line-height: 24px;
  }
  /* MOVIL */
  @media (max-width: 768px) {
    .specialView-container {
      flex-direction: column;
      align-items: center;
    }
    .specialView-image_container{
      /* display: flex;
      order: 1; */
      display: none;
    }
    .specialView-info_container {
      order: 2; 
      padding: 40px 24px;
    }
    .button {
      width: 100%;
    }
  }
  /* TABLET */
  @media (min-width: 768px) and (max-width: 992px){
    .specialView-image_container{
      display: none;
    }
    .specialView-container {
      margin: 3% auto 0;
      display: flex;
      align-items: center;
    }
  }


  /* MEDIAQUERIES QUE USAMOS */
  /* MOVIL */
  @media (max-width: 768px) {}
  /* TABLET */
  @media (min-width: 769px) and (max-width: 992px) {}


  /** ANIMACIONES */

  /* acordeon */
  .panel {
      overflow: hidden;
  }
  .accordion-enter-active,
  .accordion-leave-active {
      transition: max-height 0.4s ease, opacity 0.4s ease;
  }
  .accordion-enter {
      max-height: 0;
      opacity: 0;
  }
  .accordion-enter-to {
      max-height: 500px;
      opacity: 1;
  }
  .accordion-leave {
      max-height: 500px;
      opacity: 1;
  }
  .accordion-leave-to {
      max-height: 0;
      opacity: 0;
  }

</style>
